import { module } from "../app";

module.directive("dateInput", function () {
  return {
    restrict: "A",
    scope: {
      dateInput: '='
    },
    link: function (scope, element, attrs) {
      scope.$watch('dateInput', function () {
        var firstSlash = 2;
        var secondSlash = 5;
        if (scope.dateInput && scope.dateInput.replace && scope.dateInput.replace(/[^\d]/g, '')) {
          var firstSlash = scope.dateInput.indexOf('/');
          var secondSlash = firstSlash + 1 + scope.dateInput.substring(firstSlash + 1, scope.dateInput.length).indexOf('/');
          if (secondSlash - firstSlash == 1) {
            firstSlash = 2;
            secondSlash = 5;
          }
          scope.dateInput = scope.dateInput.replace(/[^\d]/g, '');
        } else {
          scope.dateInput = '';
        }

        var date = "" + scope.dateInput;
        date = scope.dateInput.substring(0, 8);

        var month = parseInt(date.substring(0, firstSlash));
        var year = parseInt(date.substring(secondSlash - 1, 8));
        var day = parseInt(date.substring(firstSlash, secondSlash - 1));
        var maxMonthDays = 31;

        if (('' + year).length > 4) {
          if (('' + day).length < 2) {
            secondSlash = 5;
            year = parseInt(date.substring(secondSlash - 1, 8));
            day = parseInt(date.substring(firstSlash, secondSlash - 1));
          }
          if (('' + month).length < 2) {
            firstSlash = 2;
            month = parseInt(date.substring(0, firstSlash));
            year = parseInt(date.substring(secondSlash - 1, 8));
            day = parseInt(date.substring(firstSlash, secondSlash - 1));
          }
        }

        if (month && month > 12) {
          date = '12' + date.substring(2, 6);
        }

        if (date.length > 5 && year) {
          var thatMonth = new Date(year, month, 0);
          maxMonthDays = thatMonth.getDate();
        }

        if (date.length > 3 && day && day > maxMonthDays) {
          date = date.substring(0, 2) + maxMonthDays + date.substring(4, 8);
        }

        if (date[ firstSlash ] == '/' && date[ secondSlash ] == '/') {
          return;
        }
        if (date[ firstSlash ] != '/') {
          date = date.substring(0, firstSlash) + '/' + date.substring(firstSlash);
          scope.dateInput = date.substring(0, 10);
        }
        if (date[ secondSlash ] != '/') {
          date = date.substring(0, secondSlash) + '/' + date.substring(secondSlash);
          scope.dateInput = date.substring(0, 10);
        }
      });
    }
  };
});



// WEBPACK FOOTER //
// ./src/scripts/directives/dateInput.js